// extracted by mini-css-extract-plugin
export default {"button":"styles_button__1gsEC","button_activatedEllipse":"styles_button_activatedEllipse__LKX7T","button_icon":"styles_button_icon__IJxse"};